import React from 'react';

import { ErrorOutline } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import {
  Box,
  colors
} from '@mui/material';



const __sessionIsDismissed = 'ironForgeReactModules_testModeWarningBar_isDismissed';

const __defaultBackgroundColor = colors.red[700];



export interface IStyleOptions {
  backgroundColor?: string;
  textColor?: string;
}



interface IBarDivProps {
  isClickable: boolean;
  styleOptions?: IStyleOptions;
}

const BarDiv = styled('div', {
  shouldForwardProp: prop =>
    prop !== 'isClickable' &&
    prop !== 'styleOptions'
})<IBarDivProps>(({
  theme,
  isClickable,
  styleOptions
}) => ({
  backgroundColor: styleOptions?.backgroundColor ?? __defaultBackgroundColor,
  color: styleOptions?.textColor ?? theme.palette.getContrastText(__defaultBackgroundColor),
  padding: theme.spacing(1),
  cursor: isClickable ? 'pointer' : undefined,
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center'
}));



export interface IProps {
  allowDismissForSession?: boolean;
  elMessage?: React.ReactNode;
  styleOptions?: IStyleOptions;
}

export const FC: React.FC<IProps> = props => {
  const [isVisible, setIsVisible] = React.useState(!__getIsDismissedFromSession());



  const {allowDismissForSession} = props;
  const handleClick = React.useCallback(
    () => {
      if (allowDismissForSession) {
        window.sessionStorage.setItem(__sessionIsDismissed, 'true');
        setIsVisible(false);
      }
    },
    [allowDismissForSession]
  );



  const {elMessage} = props;
  const finalElMessage = React.useMemo(
    () => elMessage ?? (
      <>
        This is NOT the production environment. <strong>DO NOT ENTER SENSITIVE INFORMATION.</strong> Only test data is allowed here.
      </>
    ),
    [elMessage]
  );



  return isVisible ? (
    <BarDiv
      isClickable={!!props.allowDismissForSession}
      onClick={handleClick}
      styleOptions={props.styleOptions}>

      <ErrorOutline />

      <Box mx={1}>
        {finalElMessage}
      </Box>

      <ErrorOutline />

    </BarDiv>
  ) : null;
};



function __getIsDismissedFromSession() {
  const value = window.sessionStorage.getItem(__sessionIsDismissed) ?? '';
  return !!value;
}
